import BaseModel from "./base/baseModel";

export default class ClienteEmailNotaFiscalModel extends BaseModel {
    id: number = null;
    clienteId: number = null;
    email: string = null;
}
